const INITIAL_VALUES = {
  conceptGroupName: '',
  account: '',
  department: null,
};

export default INITIAL_VALUES;
